
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250528-6e03e4e2rmit/ui-products/rmit/node_modules/ui-core/components/truncater/js/truncater';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250528-6e03e4e2rmit/ui-products/rmit/components/issue-item/js/issue-item';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250528-6e03e4e2rmit/ui-products/rmit/widgets/table-of-content/js/table-of-content';
  
const main = (UX) => {
    const $truncater = Array.prototype.slice.call(document.getElementsByClassName('js--truncate')),
        $issueItem = Array.prototype.slice.call(document.querySelectorAll('.issue-item__authors .loa')),
        $tocJs = Array.prototype.slice.call(document.querySelectorAll('.loa, .meta__authors'))

try {
        if ($truncater.length ) {
            UX.truncater.init($truncater);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($issueItem.length ) {
            UX.issueItem.init($issueItem);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tocJs.length ) {
            UX.tocJs.init($tocJs);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        